import { IonSearchbar } from '@ionic/react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

export const SearchbarHeader = styled.header`
	padding: 0rem 0 0.8rem;
	margin: 0;
	position: sticky;
	top: 0;
	z-index: 10;
	background: #257226;//rgba(183, 183, 138, 1);
	padding-bottom: 0;
	padding: 12px 0;
	/* backdrop-filter: blur(3px); */
`;

export const SearchbarInput = styled(IonSearchbar)`
	/* border: 1px solid red; */
	--background: #e0ec89;
	--color: #257226;
	--placeholder-color: #257226;
	--icon-color: #257226;
	--clear-button-color: #257226;
	--border-radius: 50px;
	--box-shadow: none;

	padding: 0rem 0.5rem 0 !important;

	margin-bottom: 0.25rem !important;
	--padding-start: 14px;
	--padding-end: 14px;

	.searchbar-clear-button {
		right: 5px;
		ion-icon {
			color: #257226;//var(--ion-color-secondary);
			width: 32px;
		}
	}
`;

export const FilterSwiper = styled(Swiper)`
	padding: 0rem 0.5rem;
`;

export const FilterSwiperSlide = styled(SwiperSlide)`
	width: max-content;
	ion-chip {
		padding: 0 10px 0 10px;
		font-size: 12px;
		height: 25px;
		line-height: 1;
		margin: 0;
		background: var(--text);
		&.ion-activated {
			background: var(--bg-400);
		}
		ion-icon {
			margin: 0 8px 0 0;
			font-size: 10px;
		}
	}
`;

export const UserAvatarContainer = styled.div`
	padding: 1rem;
	position: relative;
	z-index: 10;
	background-color: #257226;//var(--ion-color-light);
	/* margin-bottom: 1rem; */
	width: 100%;
	display: flex;
	gap: 1rem;
	align-items: center;
	justify-content: space-between;
	a {
		flex-grow: 0;
		display: block;
		width: 3rem;
		height: 3rem;
		aspect-ratio: 1/1;
		div {
			margin: 0 !important;
			border: 4px solid var(--ion-color-light-shade);
			border-radius: 50%;
			width: 100%;
			height: 100%;
		}
		img {
			width: 100%;
			height: 100%;
		}
	}
	h1 {
		flex-grow: 1;
		color: #ffffff;
	}
`;
